import { Link } from 'react-router-dom';
import Logo from '../assets/images/Logo.svg';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import pfasDestructionImage from '../assets/images/pfas-destruction-graph.svg';

function PfasDestuction() {
  return (
    <>
      <div className='navigation'>
        <div className='logo'>
          <img src={Logo} alt='Quantum logo' />
        </div>
        <div className='nav'>
          <Link to='/pfascycle' className='pfas-btn-white-back'>
            <div className='nav-text-back'>Previous</div>
          </Link>
          <Link to='/'>
            <div className='nav-home'></div>
          </Link>

          <div className='nav-page-nr'>5/6</div>

          <Link to='/pfasproject' className='pfas-btn-blue-next'>
            <div className='nav-text-next'>Next</div>
          </Link>
        </div>
      </div>
      <div className='pfas-destruction pfas-container'>
        <Row>
          <div className='destruction'>
            <Col xs={12} lg={6}>
              <div className='text-left'>
                <div className='slogan'> PFAS destruction</div>
                <div className='headline'>
                  How computational chemistry could help
                </div>
                <div className='text'>
                  PFAS destruction pathways can be studied in simulation using
                  computation chemistry techniques.
                </div>
                <div className='text'>
                  The term quantum chemistry also applies to classical computing
                  methods used for chemistry simulation.
                </div>

                <div className='text'>
                Many quantum chemistry problems are classically intractable due to 
                exponentially increasing compute resource requirements 
                (i.e. real world problems do not fit into our current and 
                near-future supercomputers). Quantum chemistry toolkits 
                leveraging quantum computing will provide an efficient means of 
                solving some of these problems.
                </div>
                <div className='text'>
                  The simulations could help to identify best pathways or
                  catalysts to solve the problem through engineering solutions.
                  Material scientists and chemical engineers need this
                  information to be able to manufacture those materials and
                  eliminate PFAS from the enviroment.
                </div>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <div className='image-right'>
                <div className='image'>
                  <img
                    src={pfasDestructionImage}
                    alt='destruction graph'
                  />
                </div>
              </div>
            </Col>
          </div>
        </Row>
      </div>
    </>
  );
}

export default PfasDestuction;
